/**
 * Event utility functions
 *
 * Helper functions for working with event data, including date
 * filtering and validation.
 */

import { DateTime } from 'luxon';
import type { UpcomingEvent } from '../types/api.types';

/**
 * Determines if an event should be displayed based on its date
 *
 * Logic:
 * - First event (index 0) is always shown
 * - Events with date 'TBC' (To Be Confirmed) are shown
 * - Events with dates from today onwards are shown
 * - Past events are filtered out
 *
 * @param event - The event to check
 * @param index - The position of the event in the array (0-based)
 * @returns true if the event should be displayed, false otherwise
 */
export const isEventFromToday = (event: UpcomingEvent, index: number): boolean => {
  // Always show the first event regardless of date
  if (index === 0) {
    return false;
  }

  // Show events with unconfirmed dates
  if (event.date === 'TBC') {
    return true;
  }

  // Parse the date and check if it's today or in the future
  const eventDate = DateTime.fromFormat(event.date, 'dd/MM/yyyy');
  const today = DateTime.now().startOf('day');
  const result = eventDate >= today;

  return result;
};
